// extracted by mini-css-extract-plugin
export default {"midnightLink":"MidnightLinkButton-module__midnightLink___Gp_PZ"};